import React, { useState } from "react";
import {
  Grid,
  Typography,
  Box,
  Paper,
  Dialog,
  TextField,
  Button,
} from "@mui/material";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const initialEvents = [
  {
    id: 1,
    day: "Monday",
    title: "Meeting with Tim",
    time: "02:00 AM",
    duration: 60,
  }, // 1 hour
  {
    id: 2,
    day: "Monday",
    title: "Meeting with team",
    time: "01:00 AM",
    duration: 30,
  }, // 30 minutes
  {
    id: 3,
    day: "Monday",
    title: "Meeting with Josh",
    time: "01:00 AM",
    duration: 90,
  }, // 1.5 hours
  {
    id: 4,
    day: "Monday",
    title: "Design Review",
    time: "15:30 PM",
    duration: 60,
  }, // 1 hour
  // { day: "Wednesday", title: "Project Deadline", time: "13:15 PM" },
  // { day: "Wednesday", title: "Project Deadline", time: "13:15 PM" },
  // { day: "Friday", title: "Weekly Review", time: "16:00 PM" },
];

const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];

const timeSlots = Array.from({ length: 11 }, (_, i) => {
  const hour = i + 10;
  const formattedHour =
    hour < 12
      ? `${hour}:00 AM`
      : hour === 12
      ? "12:00 PM"
      : `${hour - 12}:00 PM`;
  return formattedHour;
});

const WeeklyCalendar = () => {
  const [events, setEvents] = useState(initialEvents);
  const [open, setOpen] = useState(false);
  const [newEvent, setNewEvent] = useState({
    day: "",
    time: "",
    title: "",
  });

  const handleSlotClick = (day, time) => {
    setNewEvent({ ...newEvent, day, time });
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setNewEvent({ day: "", time: "", title: "" });
  };

  const handleSave = () => {
    const [hour, minute] = newEvent.time.split(":");
    const eventHour = parseInt(hour, 10);
    const period = newEvent.time.includes("PM") ? "PM" : "AM";

    let adjustedHour = eventHour;
    if (period === "PM" && eventHour !== 12) adjustedHour += 12;
    if (period === "AM" && eventHour === 12) adjustedHour = 0;

    if (adjustedHour < 10 || adjustedHour >= 20) {
      alert("Please schedule events between 10:00 AM and 8:00 PM.");
      return;
    }

    setEvents([...events, newEvent]);
    handleClose();
  };

  return (
    <Box
      sx={{
        padding: 4,
        width: "90%",
        margin: "0 auto",
        display: "flex",
        justifyContent: "space-around",
      }}
    >
      {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateCalendar />
      </LocalizationProvider> */}
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 3,
          }}
        >
          <Typography variant="h4" sx={{ fontWeight: "bold" }}>
            This Week
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Jan 8 - Jan 12
          </Typography>
        </Box>

        <Grid container sx={{ overflowX: "auto", maxHeight: "80vh" }}>
          <Grid item xs={1} sx={{ borderRight: "1px solid #e0e0e0" }}>
            {timeSlots.map((time, index) => {
              if (index === 0) {
                return (
                  <>
                    <Box
                      key={`fake-${index}`}
                      sx={{
                        height: 44,
                        padding: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderBottom: "1px solid #f0f0f0",
                        color: "text.secondary",
                      }}
                    >
                      <Typography variant="caption"></Typography>
                    </Box>
                    <Box
                      key={index}
                      sx={{
                        height: 60,
                        padding: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderBottom: "1px solid #f0f0f0",
                        color: "text.secondary",
                      }}
                    >
                      <Typography variant="caption">{time}</Typography>
                    </Box>
                  </>
                );
              } else {
                return (
                  <Box
                    key={index}
                    sx={{
                      height: 60,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderBottom: "1px solid #f0f0f0",
                      color: "text.secondary",
                    }}
                  >
                    <Typography variant="caption">{time}</Typography>
                  </Box>
                );
              }
            })}
          </Grid>
          {days.map((day) => (
            <Grid
              item
              xs={11 / days.length}
              key={day}
              sx={{
                borderLeft: "1px solid #e0e0e0",
                "&:first-of-type": { borderLeft: "none" },
                width: "120px",
              }}
            >
              <Box
                sx={{
                  padding: 1,
                  backgroundColor: "#f9f9f9",
                  borderBottom: "1px solid #e0e0e0",
                  textAlign: "center",
                }}
              >
                <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                  {day}
                </Typography>
              </Box>
              <Box sx={{ position: "relative", height: 60 * timeSlots.length }}>
                {timeSlots.map((time, index) => (
                  <Box
                    key={index}
                    sx={{
                      height: 60,
                      borderBottom: "1px solid #f0f0f0",
                      cursor: "pointer",
                      "&:hover": { backgroundColor: "#f5f5f5" },
                    }}
                    onClick={() => handleSlotClick(day, time)}
                  />
                ))}
                {events
                  .filter((event) => event.day === day)
                  .map((event, index, filteredEvents) => {
                    const [hour, minute] = event.time.split(":");
                    const eventHour = parseInt(hour, 10);
                    const eventMinute = parseInt(minute.split(" ")[0], 10);
                    const period = event.time.includes("PM") ? "PM" : "AM";

                    // Convert time to 24-hour format
                    let adjustedHour = eventHour;
                    if (period === "PM" && eventHour !== 12) adjustedHour += 12;
                    if (period === "AM" && eventHour === 12) adjustedHour = 0;

                    const startHour = 10; // Calendar starts at 10 AM
                    const totalHoursFromStart =
                      adjustedHour + eventMinute / 60 - startHour; // Offset from startHour

                    // Find overlapping events
                    const overlappingEvents = filteredEvents.filter((e) => {
                      const [eHour, eMinute] = e.time.split(":");
                      const eEventHour = parseInt(eHour, 10);
                      const eEventMinute = parseInt(eMinute.split(" ")[0], 10);
                      const ePeriod = e.time.includes("PM") ? "PM" : "AM";

                      let eAdjustedHour = eEventHour;
                      if (ePeriod === "PM" && eEventHour !== 12)
                        eAdjustedHour += 12;
                      if (ePeriod === "AM" && eEventHour === 12)
                        eAdjustedHour = 0;

                      const eTotalHoursFromStart =
                        eAdjustedHour + eEventMinute / 60 - startHour;

                      return (
                        e.day === event.day &&
                        Math.abs(eTotalHoursFromStart - totalHoursFromStart) < 1 // Overlapping threshold
                      );
                    });

                    // Calculate width and left position for overlapping events
                    const eventWidth = 100 / overlappingEvents.length; // Divide width equally
                    const eventIndex = overlappingEvents.findIndex(
                      (e) => e.title === event.title
                    );
                    const leftPosition = eventWidth * eventIndex;
                    const eventHeight = event.duration * (60 / 60);
                    return (
                      <Paper
                        key={index}
                        sx={{
                          position: "absolute",
                          top:
                            totalHoursFromStart > 12
                              ? (totalHoursFromStart - 12) * 60
                              : (totalHoursFromStart + 12) * 60,
                          height: eventHeight,
                          width: `calc(${eventWidth}% - 10%)`, // Adjust width for spacing
                          left: `calc(${leftPosition}% + 4px)`, // Adjust position with spacing
                          padding: 1,
                          backgroundColor: "#e3f2fd",
                          borderRadius: 1,
                          boxShadow: 1,
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          sx={{
                            fontWeight: "bold",
                            overflow: "hidden", // Hide the overflowing content
                            textOverflow: "ellipsis", // Add ellipsis when the text overflows
                            whiteSpace: "nowrap",
                          }}
                        >
                          {event.title}
                        </Typography>
                      </Paper>
                    );
                  })}
              </Box>
            </Grid>
          ))}
        </Grid>
        <Dialog open={open} onClose={handleClose}>
          <Box sx={{ padding: 3 }}>
            <Typography variant="h6" sx={{ marginBottom: 2 }}>
              Add Event
            </Typography>
            <TextField
              fullWidth
              label="Event Title"
              value={newEvent.title}
              onChange={(e) =>
                setNewEvent({ ...newEvent, title: e.target.value })
              }
              sx={{ marginBottom: 2 }}
            />
            <Typography variant="body1" sx={{ marginBottom: 2 }}>
              Day: {newEvent.day}, Time: {newEvent.time}
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Button onClick={handleClose} variant="outlined">
                Cancel
              </Button>
              <Button onClick={handleSave} variant="contained">
                Save
              </Button>
            </Box>
          </Box>
        </Dialog>
      </Box>
    </Box>
  );
};

export default WeeklyCalendar;
